export default __webpack_public_path__ + "static/media/Quiken_Envios_Locales-03.3c28027d.svg";